<template>
  <AdaptersDialog
      :listener-id="name"
      :header="header"
  >
      <template #content>
        <div class="modal-body">
          <div class="modal-notification" v-html="message"></div>
        </div>
      </template>
      <template #footer="vm">
          <div class="modal-footer">
              <a href="#" class="graybutton" @click.prevent="vm.onClose">{{ $t('lang.modal.close') }}</a>
          </div>
      </template>
  </AdaptersDialog>
</template>

<script>
import AdaptersDialog from "../adapters/Dialog.vue";

export default {
  name: "KsModal",
  props: {
    header: {
      type: String,
      default() {
        return this.$t('lang.modal.notification')
      }
    },
    name: {
      type: String,
      default: "ks-modal"
    },
    message: {
      type: String,
      default: "Ops..."
    }
  },
    components: {
      AdaptersDialog,
    }
}
</script>
